<template>
  <van-popup :value="value" @input="onShowChange" :close-on-click-overlay="false">
    <div class="bg-white choose-product-wrap">
      <div class="text-center">Choose Product</div>
      <div class="grid grid-cols-4 gap-1 mt-4 w-full">
        <ProductItem
            v-for="(item,index) in myProducts"
            :key="item.id"
            :selected="item.selected"
            :product-info="item"
            @onSelectProduct="onSelectProduct(item,index)"/>
      </div>
      <div class="apply-btn" @click="onApply"> Apply</div>
    </div>

    <div class="flex flex-col items-center">
      <img :src="require('@/assets/icons/v2/icon_popup_close.png')" class="w-9 h-9 mt-6 p-2"
          @click="onCancel(false)"/>
    </div>
  </van-popup>
</template>

<script>
import DeviceItem from "@/components/customization/ProductItem.vue";
import ProductItem from "@/components/customization/ProductItem.vue";

export default {
  name: "PopupChooseProduct",
  components: { ProductItem, DeviceItem },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    myProducts: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      form: {
        brandname: ""
      }
    };
  },
  methods: {
    onShowChange(e) {
      this.$emit("input", e);
    },
    onCancel() {
      this.$emit('input',false)
      this.$emit('onClose')
    },
    onSelectProduct(item, index) {
      this.$emit("onSelectProduct", item, index);
    },
    onApply() {
      this.$emit("input", false);
      this.$emit('onApplyDevice')
    }
  }
};
</script>

<style scoped lang="less">
.brand-info-wrap {
  border-radius: 12px;
  background: white;
  padding: 1.33rem;

  min-width: 20rem;
  //height: 23rem;
}

::v-deep .van-field__value {
  box-sizing: border-box;
  border: 1px solid #E8E8E8;
  border-radius: 12px;
}

.upload-image-wrap {
  border: 1px #E8E8E8 solid;
  width: 8.5rem;
  height: 8.5rem;
  border-radius: 1rem;
  margin-top: 1.33rem;
}

.default-brand-img {
  width: 4rem;
  height: 4rem;
}

.choose-product-wrap {
  padding: 16px;
  border-radius: 12px;
  width: 80vw;
}

.van-popup {
  background: transparent;
}

.apply-btn {
  background: #333333;
  color: white;
  border-radius: 12px;
  text-align: center;
  margin-top: 24px;
  height:40px;
  line-height: 40px;
}
</style>